import { query_post_sale_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model/mjstore/mjstore-postsale-config';

import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { getDateTime } from '@/utils/function';

export default () => {
  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);
  const None = null;

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
      col: [],
    },
    fields: [
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '执行门店',
        disabled: !!current_shop,
        placeholder: '请选择执行门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      customer_id: null,
      shop_id: current_shop?.id,
    }),
  };
  const search_options = {};

  const edit_model_config: SearchConfig = {
    settings: {},
    fields: [],
    rules: {},
    model: reactive({}),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {},
    fields: [],
    rules: {},
    model: reactive({}),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '产品跟进',
    addModalTitle: '新建产品跟进',
    updateTitle: '修改产品跟进',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {};

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '会员编号',
      width: 150,
      dataIndex: 'customer__code',
      checked: true,
    },
    {
      title: '会员姓名',
      width: 150,
      dataIndex: 'customer__name',
      checked: true,
    },
    {
      title: '耗单日期',
      width: 150,
      dataIndex: 'date',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '耗单号',
      width: 180,
      dataIndex: 'order_used_record__order_code',
      checked: true,
    },
    {
      title: '项目名称',
      width: 180,
      dataIndex: 'order_used_record__project__name',
      checked: true,
    },
    {
      title: '项目次数',
      width: 80,
      dataIndex: 'order_used_record__num',
      checked: true,
    },

    {
      title: '销售执行门店',
      width: 120,
      dataIndex: 'order_used_record__shop__name',
      checked: true,
    },
    {
      title: '销售执行人',
      width: 120,
      dataIndex: 'order_used_record__staff__name',
      checked: true,
    },
    {
      title: '使用情况',
      width: 600,
      dataIndex: 'note',
      checked: true,
    },
    {
      title: '跟进执行门店',
      width: 120,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '跟进执行人',
      width: 100,
      dataIndex: 'staff__name',
      checked: true,
    },
    {
      title: '最近跟进日期',
      width: 150,
      dataIndex: 'last_date',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 80,
      checked: true,
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_post_sale_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
